
/**
 * 트렌드 통계 정보
 */
export type TrendItemStats = {
  count?: number;
};
